import React from "react"
import { useTranslation } from "react-i18next"

import { DEFAULT_PRICE_CURRENCY } from "shared/constants/app-constants"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { NumberInput } from "shared/ui/input/number/NumberInput"

import { PriceTag } from "widgets/price-tag/PriceTag"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"
import { useProductPositionFormPriceContext } from "../../contexts/ProductPositionFormPriceContext"

export const ProductPositionPriceInput = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoading, isLoadingPrice } = useProductPositionFormLoadingContext()
  const { price, isPriceOverwritten, isUnitPriceEditable } =
    useProductPositionFormPriceContext()
  const { hidePrice, isPriceReadonly } = formOptions || {}

  if (hidePrice || (!isReadonly && !isUnitPriceEditable)) return null

  return (
    <NumberInput.Root
      name="price"
      className="product-position-form__price"
      label={t("Price.UnitPrice")}
      readonly={isReadonly || isPriceReadonly}
      loading={isLoading || isLoadingPrice}
      data-testid="product-position-form__price"
      disabled={isDisabled}
      step={1}
      format={{ maximumFractionDigits: 2 }}
    >
      <NumberInput.Label
        icon={isPriceOverwritten ? IconName.USER_PEN : undefined}
      />
      <NumberInput.Group>
        <NumberInput.Focus>
          <NumberInput.Input data-testid="product-position-form__price__input" />
          <NumberInput.Affix>
            {price?.currency || DEFAULT_PRICE_CURRENCY}
          </NumberInput.Affix>
        </NumberInput.Focus>
      </NumberInput.Group>
      <NumberInput.Readonly>
        <PriceTag
          hideLabel
          price={price?.itemPrice}
          currency={price?.currency}
          isComplete={price?.isComplete}
        />
      </NumberInput.Readonly>
      <NumberInput.ErrorMessage />
    </NumberInput.Root>
  )
})
